export var LEFT_ORIENTATION = 'left';
export var RIGHT_ORIENTATION = 'right';